import { render, staticRenderFns } from "./app-primary.vue?vue&type=template&id=5dc4f370&scoped=true&"
import script from "./app-primary.vue?vue&type=script&lang=js&"
export * from "./app-primary.vue?vue&type=script&lang=js&"
import style0 from "./app-primary.vue?vue&type=style&index=0&id=5dc4f370&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc4f370",
  null
  
)

export default component.exports